import styled from 'styled-components'

import theme from 'theme'

const Tag = styled.div`
  font-size: ${theme.fontSizes[50]}px;
  color: ${theme.colors.black};
  font-weight: ${theme.fontWeights.lightest};
`

export default Tag
